import { TRIP_TYPE_CODES } from './tripTypes';

/**
 * Field path identifiers for member supplemental information required by certain levels of service.
 * Maps simple keys to member attribute path strings for required supplemental information.
 * These paths are used when validating if member information meets requirements for a
 * selected level of service.
 *
 * @property {string} height - Path to member document's height in inches
 * @property {string} weight - Path to member document's weight in pounds
 * @property {string} documents - Path to member document's documents
 */
export const REQUIRED_SUPPLEMENTAL_INFO_KEY_TO_MEMBER_ATTRIBUTE_PATH =
  Object.freeze({
    height: 'patient.heightInInches',
    weight: 'patient.weightInLbs',
    documents: 'patient.documents.*',
  });

/**
 * Maps a specific level of service (keyed by lower-cased `displayText`) to the
 * single trip type it is valid for. Levels of service not listed here are valid
 * for any trip type.
 */
export const ALLOWED_TRIP_TYPE_FOR_SPECIFIC_LOS = Object.freeze({
  gmr: TRIP_TYPE_CODES.MILEAGE_REIMBURSEMENT,
  'mileage reimbursement': TRIP_TYPE_CODES.MILEAGE_REIMBURSEMENT,
  ancillary: TRIP_TYPE_CODES.ANCILLARY_SERVICES,
  'ancillary service': TRIP_TYPE_CODES.ANCILLARY_SERVICES,
  'ancillary services': TRIP_TYPE_CODES.ANCILLARY_SERVICES,
  'public transport': TRIP_TYPE_CODES.PUBLIC_TRANSPORTATION,
  'public transportation': TRIP_TYPE_CODES.PUBLIC_TRANSPORTATION,
});
